'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./~/react-router/~/react/react.js
// module id = 50
// module chunks = 168707334958949